import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';

import { Section, SectionTitle, BlockSection } from 'components/ModalFormLayout';
import Input from '@ontruck/ontruck-react-components/lib/Input';
import Button from '@ontruck/ontruck-react-components/lib/Button';
import ButtonGroup from '@ontruck/ontruck-react-components/lib/ButtonGroup';
import { Checkbox } from '@ontruck/orc';
import UsersRoutes from '../UsersRoutes';
import cx from 'classnames';
import style from './style.module.scss';

const groupsRadios = ['Manager', 'Operator', 'ProdTech'];

class InputComponent extends Component {
  handleChange = (value) => {
    this.props.onChange(this.props.name, value);
  };

  render() {
    const { label, value, name, error, dirty } = this.props;

    return (
      <div>
        <Input
          className={cx({ [style.fieldError]: dirty && error, [style.detailsInput]: true })}
          onChange={this.handleChange}
          value={value}
          name={name}
          label={label}
        />
        {dirty && error && <span className={style.textError}>{error}</span>}
      </div>
    );
  }
}

InputComponent.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  error: PropTypes.string,
  dirty: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

class RadioButtonsComponents extends Component {
  handleChange = (value) => {
    this.props.onChange(this.props.name, value);
  };

  render() {
    const { value, error, dirty, buttonsData } = this.props;
    return (
      <ButtonGroup
        className={cx({ [style.fieldError]: dirty && error })}
        light
        active={value}
        onChange={this.handleChange}
      >
        {buttonsData.map((group) => (
          <Button
            small
            className={cx({ [style.fieldError]: error })}
            key={group.value}
            value={group.value}
          >
            {group.string}
          </Button>
        ))}
      </ButtonGroup>
    );
  }
}

RadioButtonsComponents.propTypes = {
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  error: PropTypes.string,
  dirty: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  buttonsData: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      string: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};

const UserForm = ({
  handleChange,
  values,
  setFieldValue,
  errors,
  dirty,
  editing,
  routes,
  intl,
  me,
  userId,
  clearCacheStaff,
}) => {
  const t = intl.messages.components.UsersForm;
  const handleClearCacheClick = (e) => {
    e.preventDefault();
    clearCacheStaff(userId);
  };

  return (
    <div>
      <Section>
        <SectionTitle>{t.titles.user_details}</SectionTitle>
        {editing && values.email ? (
          <p>{values.email}</p>
        ) : (
          <InputComponent
            value={values.email}
            name="email"
            label={t.labels.email}
            onChange={setFieldValue}
            error={errors.email}
            dirty={dirty}
          />
        )}

        <InputComponent
          value={values.first_name}
          name="first_name"
          label={t.labels.first_name}
          onChange={setFieldValue}
        />

        <InputComponent
          value={values.last_name}
          name="last_name"
          label={t.labels.last_name}
          onChange={setFieldValue}
        />
      </Section>
      <Section>
        <SectionTitle>{t.titles.role}</SectionTitle>
        <RadioButtonsComponents
          value={values.group}
          name="group"
          onChange={setFieldValue}
          error={errors.group}
          dirty={dirty}
          buttonsData={groupsRadios.map((group) => ({ value: group, string: t.labels[group] }))}
        />
      </Section>
      <Section>
        <Checkbox
          label={t.labels.is_dispatcher}
          size="M"
          checked={values.isDispatcher}
          onChange={(event, { value }) => {
            setFieldValue('isDispatcher', value);
          }}
        />
        <Checkbox
          label={t.labels.is_customer_service}
          size="M"
          checked={values.isCustomerService}
          onChange={(event, { value }) => {
            setFieldValue('isCustomerService', value);
          }}
        />
      </Section>

      {values.group && values.group !== 'ProdTech' && (
        <Section>
          <SectionTitle>{t.titles.routes}</SectionTitle>
          <UsersRoutes
            className={cx({ [style.fieldError]: errors.routes })}
            enabledRoutes={values.routes}
            routes={routes}
            onChange={(val) => setFieldValue('routes', val)}
          />
        </Section>
      )}

      <BlockSection
        title={t.titles.available}
        checked={!values.available}
        onChange={(val) => setFieldValue('available', !val)}
        labels={{
          enabled: t.labels.yes,
          blocked: t.labels.no,
        }}
      />
      {editing && (
        <BlockSection
          title={t.titles.active_user}
          checked={!values.is_active}
          onChange={(val) => setFieldValue('is_active', !val)}
          labels={{
            enabled: t.labels.yes,
            blocked: t.labels.no,
          }}
        />
      )}

      {editing && me.groups.includes('ProdTech') && (
        <Section>
          <SectionTitle>{t.titles.management}</SectionTitle>
          <Button onClick={handleClearCacheClick}>{t.labels.clear_cache}</Button>
        </Section>
      )}
    </div>
  );
};

UserForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,
  dirty: PropTypes.bool.isRequired,
  values: PropTypes.shape({
    idDispatcher: PropTypes.bool.isRequired,
    email: PropTypes.string.isRequired,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    group: PropTypes.string,
    is_active: PropTypes.bool,
    routes: PropTypes.array,
  }).isRequired,
  editing: PropTypes.bool,
  routes: PropTypes.array,
  intl: PropTypes.object.isRequired,
  me: PropTypes.object,
  userId: PropTypes.string,
  clearCacheStaff: PropTypes.func.isRequired,
};

export default injectIntl(UserForm);
